(() => {
  if (window.sleepingBagModelsLoaded) return;
  window.sleepingBagModelsLoaded = true;
  const cache = new WeakMap();

  function productsFor(card) {
    if (!cache.has(card)) {
      const source = card.querySelector('[data-model-products]');
      cache.set(card, source ? JSON.parse(source.textContent) : []);
    }
    return cache.get(card);
  }

  function syncSwatches(card, product) {
    card.querySelectorAll('[data-model-color]').forEach(swatch => {
      const label = swatch.dataset.modelColorLabel;
      swatch.setAttribute('aria-label', label);
      swatch.title = label;
      swatch.setAttribute('aria-pressed', String(swatch.dataset.modelColor === product.color));
    });
    const colorName = card.querySelector('[data-model-color-name]');
    if (colorName) colorName.textContent = product.color;
  }

  function update(card, requestedColor) {
    const products = productsFor(card);
    if (!products.length) return;
    const size = card.querySelector('[data-model-size]');
    const selectedSize = size ? size.value : '';
    const selectedSwatch = card.querySelector('[data-model-color][aria-pressed="true"]');
    const selectedColor = requestedColor ?? selectedSwatch?.dataset.modelColor ?? '';
    const matches = products.filter(p => p.size === selectedSize);
    let product = matches.find(p => p.color === selectedColor);
    if (!product && requestedColor !== undefined) {
      const colorMatches = products.filter(p => p.color === requestedColor);
      product = colorMatches.find(p => p.available) || colorMatches[0];
    }
    if (!product) product = matches.find(p => p.available) || matches[0];
    if (!product) return;
    if (size) size.value = product.size;
    syncSwatches(card, product);
    const price = card.querySelector('[data-model-price]');
    if (price) price.textContent = product.price;
    card.querySelectorAll('.grid-product__link, [data-model-view]').forEach(link => {
      link.setAttribute('href', product.url);
    });
    const image = card.querySelector('.product-image-frame img');
    if (image && product.image) {
      image.removeAttribute('srcset');
      image.setAttribute('src', product.image);
      image.setAttribute('alt', product.alt);
    }
    const secondary = card.querySelector('.grid-product__secondary-image');
    if (secondary) secondary.hidden = true;
    const stock = card.querySelector('[data-model-stock]');
    if (stock) stock.hidden = product.available;
    const oldSoldOut = card.querySelector('.grid-product__tag--sold-out');
    if (oldSoldOut) oldSoldOut.hidden = product.available;
    const options = card.querySelector('[data-model-options]');
    if (options) options.dataset.modelSelectedId = String(product.id);
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-model-size]')) return;
    const card = event.target.closest('[data-model-card]');
    if (card) update(card);
  });
  document.addEventListener('click', event => {
    const swatch = event.target.closest('[data-model-color]');
    if (!swatch) return;
    const card = swatch.closest('[data-model-card]');
    if (card) update(card, swatch.dataset.modelColor);
  });
})();
